import {CURRENT_SERVER} from '@/constants/domains'
import VueCookie from 'vue-cookie'

const axios = require('axios')

export default {
  createPayment: function (payment) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      company: VueCookie.get('company'),
      headers: {'Authorization': 'Bearer ' + VueCookie.get('token')}
    })
    return instCred.post('payments', payment)
  },
  getPayments: function ({limit = 30, page = 1, filter}) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.get(`payments?&sort[]=paymentDate&sort[]=-1&page=${page}&limit=${limit}&${filter}`)
  },
  editPayment: function (body, id) {
    body.company = VueCookie.get('company')
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.put('payments/' + id, body)
  },
  delPayment: function (id) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.delete('payments/' + id)
  }
}



// WEBPACK FOOTER //
// ./src/api/Payment/api.js